// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"56e904f1","455":"2f04ce6a"}[chunkId] + ".chunk.js";
};